import { CarouselImageModel } from './carousel-image-model';

export class ImageGalleryModel {
    id: number;
    title: string;
    carouselImages: CarouselImageModel[];
    selected: boolean;
}
